<script lang="ts">
  import { inview } from 'svelte-inview';

  import type { Photo } from '@do/models';

  import { pointer } from '@shared/libs/tools';
  import { cn, is } from '@shared/utils';

  import { artAssetCardLibs } from '@entities/art-asset';
  import { searchLibs } from '@entities/search';

  import CardTemplate from './card-template.svelte';

  export let item: {
    cover: Photo | null;
    slug: string;
    title: string;
  };
  export let totalCount: number;

  const options = { rootMargin: '0px', threshold: 0.1 };
  const appearanceDelay = artAssetCardLibs.imageIdToNumber(item.cover?.id);

  let wasInview = false;
  let isImageLoaded = false;
  let imgElement: HTMLImageElement;

  $: isVisible = (item.cover ? isImageLoaded : true) && wasInview;
  $: opacityTransitionClasses = `transition-opacity ${is(isVisible, 'opacity-1', 'opacity-0')} duration-500`;

  function handleEnter() {
    wasInview = true;
  }

  function handleImageLoad() {
    isImageLoaded = true;
  }
</script>

<div use:inview="{options}" on:inview_enter="{handleEnter}">
  <div class="group relative flex w-full break-inside-avoid items-center gap-5 transition-transform duration-500">
    <div
      class="{is(
        isVisible,
        'opacity-1 translate-y-0 scale-100',
        'translate-y-[80%] scale-75 opacity-0',
      )} mb-2 overflow-hidden [transition:opacity_0.5s,transform_0.8s]
"
      style="transition-delay: {appearanceDelay}ms;"
    >
      <div
        class="relative w-full cursor-pointer rounded-lg {is(
          isVisible,
          'translate-y-0',
          '-translate-y-[60%]',
        )} [transition:transform_0.8s]"
        use:pointer="{'view'}"
        style="transition-delay: {appearanceDelay}ms;"
      >
        <CardTemplate
          cover="{item.cover}"
          slug="{item.slug}"
          title="{item.title}"
          on:navigate
          on:load="{handleImageLoad}"
          bind:imgElement
          classes="grid grid-cols-[80px_1fr] gap-5 items-center"
          hasHover="{false}"
        >
          <p
            class="underline-hover mb-1 {opacityTransitionClasses}"
            style="transition-delay: {searchLibs.getTransitionDelay(1, appearanceDelay)}"
            slot="title"
          >
            {item.title}
          </p>

          <p
            class="{cn('text-default-500 dark:text-default-50/60', opacityTransitionClasses, {
              hidden: !totalCount,
            })}"
            style="transition-delay: {searchLibs.getTransitionDelay(2, appearanceDelay)}"
            slot="total-count"
          >
            Selections • {totalCount}
          </p>
        </CardTemplate>
      </div>
    </div>
  </div>
</div>
